import React from "react";
import classNames from "classnames";
import styles from "./Input.module.scss";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";

const Input = ({
  className,
  wrapperClassName = "",
  icon: Icon,
  iconPosition = "right",
  iconStyle,
  field,
  form,
  isClearable,
  onClear,
  autoComplete = "off",
  ...props
}) => {
  const renderIcon = (Icon) => {
    if (!Icon) return null;

    if (React.isValidElement(Icon)) {
      return React.cloneElement(Icon, { style: iconStyle });
    }

    // If it's a string (e.g. a path to an image)
    if (typeof Icon === "string") {
      return <img src={Icon} alt="icon" style={iconStyle} />;
    }

    // If it's a valid React component
    if (typeof Icon === "function" || React.isValidElement(<Icon />)) {
      return <Icon style={iconStyle} />;
    }

    // Otherwise, invalid type
    console.warn("Invalid icon passed to Input:", Icon);
    return null;
  };

  return (
    <div className={classNames(styles.wrapper, wrapperClassName)}>
      <div className={styles.inputWrapper} data-icon-position={iconPosition}>
        <input
          {...field}
          {...props}
          autoComplete={autoComplete}
          className={classNames(styles.inputContainer, className, {
            [styles.errorBorder]:
              form?.errors[field.name] && form.touched[field.name],
            [styles.withIcon]: !!Icon,
          })}
        />
        {Icon && <span className={styles.inlineIcon}>{renderIcon(Icon)}</span>}
        {isClearable && props.value && (
          <button
            type="button"
            className={styles.clearButton}
            onClick={() => {
              onClear?.();
              if (props.onChange) {
                props.onChange({ target: { value: "" } }); // Ensure value is cleared
              }
            }}
          >
            <CloseIcon />
          </button>
        )}
      </div>
      {form?.errors[field.name] && form.touched[field.name] && (
        <div className={styles.error}>{form.errors[field.name]}</div>
      )}
    </div>
  );
};

export default Input;
